import React from 'react';
import { HeroV2 } from '../components/HeroV2';
import { PartnerLogos } from '../components/PartnerLogos';
import { Stats } from '../components/Stats';
import { Services } from '../components/Services';
import { Advantages } from '../components/Advantages';
import { Testimonial } from '../components/Testimonial';
import { News } from '../components/News';
import { Newsletter } from '../components/Newsletter';
export function HomeV2() {
  return <main id="main-content" data-id="element-519">
      <HeroV2 data-id="element-520" />
      <PartnerLogos data-id="element-521" />
      <Stats data-id="element-522" />
      <Services data-id="element-523" />
      <Advantages data-id="element-524" />
      <Testimonial data-id="element-525" />
      <News data-id="element-526" />
      <Newsletter data-id="element-527" />
    </main>;
}